// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DvQj","colMin":"styles_colMin__5JYUQ"};